<template>
  <div>
    <v-btn
      v-if="!isEditMode"
      text
      color="#E8E8E8"
      icon
      @mouseenter="isHovered = true"
      @mouseleave="isHovered = false"
      @click="dialog = true"
    >
      <v-icon v-if="!isHovered">mdi-plus-circle</v-icon>
      <v-icon v-if="isHovered">mdi-plus-circle</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card>
        <v-card-title><span class="headline">New Anchor</span></v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <!-- <v-col :cols="12">
                <v-text-field placeholder="Name" v-model="name"></v-text-field>
              </v-col> -->
              <v-col :cols="6">
                <v-text-field
                  placeholder="Variable"
                  v-model="variable"
                ></v-text-field>
              </v-col>
              <v-col :cols="6">
                <v-text-field
                  placeholder="Value"
                  v-model="value"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <p
                v-if="showAnchorVariableError"
                style="font-size: medium; color: red; font-weight: 500; margin-left: 12px;"
              >
                The variable name should start with
                <span>"context.state"</span> or
                <span>"context.patient"</span> or
                <span>"context.metadata"</span>.
              </p>
            </v-row>
          </v-container></v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            class="white-text"
            :disabled="variable.length === 0 || value.length === 0"
            @click="enableNameEditMode()"
          >
            Save
          </v-btn>
          <v-btn color="red" class="white-text" @click="closeDialog()">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    out: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      isHovered: false,
      isEditMode: false,
      showAnchorVariableError: false,
      name: "",
      variable: "",
      value: "",
    };
  },
  methods: {
    enableNameEditMode() {
      if (
        this.variable.length > 0 &&
        (this.variable.startsWith("context.state") ||
          this.variable.startsWith("context.patient") ||
            this.variable.startsWith("context.metadata")) &&
        this.value.length > 0
      ) {
        this.$emit("created", {
          name: this.name,
          in: !this.out,
          out: this.out,
          variable: this.variable,
          value: this.value,
        });
        this.showAnchorVariableError = false;
        this.dialog = false;
        this.name = "";
        this.variable = "";
        this.value = "";
      } else {
        this.showAnchorVariableError = true;
      }
    },
    closeDialog() {
      this.dialog = false;
      this.variable = "";
      this.value = "";
    },
  },
};
</script>

<style>
.white-text {
  color: white !important;
  font-weight: bold;
}
</style>
